// Shared HID Usage definitions and labels

export enum HidUsage {
  NOT_ASSIGNED = 0x000000,
  X = 0x010030,
  Y = 0x010031,
  Z = 0x010032,
  RX = 0x010033,
  RY = 0x010034,
  RZ = 0x010035,
  HAT_SWITCH = 0x010039,
  ACCELL = 0x0200C4,
  BRAKE = 0x0200C5,
  BUTTON_1 = 0x090001,
  BUTTON_2 = 0x090002,
  BUTTON_3 = 0x090003,
  BUTTON_4 = 0x090004,
  BUTTON_5 = 0x090005,
  BUTTON_6 = 0x090006,
  BUTTON_7 = 0x090007,
  BUTTON_8 = 0x090008,
  BUTTON_9 = 0x090009,
  BUTTON_10 = 0x09000A,
  BUTTON_11 = 0x09000B,
  BUTTON_12 = 0x09000C,
  BUTTON_13 = 0x09000D,
  BUTTON_14 = 0x09000E,
  BUTTON_15 = 0x09000F,
  BUTTON_16 = 0x090010,
  BUTTON_17 = 0x090011,
  BUTTON_18 = 0x090012,
  BUTTON_19 = 0x090013,
  BUTTON_20 = 0x090014,
  BUTTON_21 = 0x090015,
  BUTTON_22 = 0x090016,
  BUTTON_23 = 0x090017,
  BUTTON_24 = 0x090018,
  BUTTON_25 = 0x090019,
  BUTTON_26 = 0x09001A,
  BUTTON_27 = 0x09001B,
  BUTTON_28 = 0x09001C,
  BUTTON_29 = 0x09001D,
  BUTTON_30 = 0x09001E,
  BUTTON_31 = 0x09001F,
  BUTTON_32 = 0x090020,

  INTG0_QA = 0xFFF00000, // Encoder 0, quadrature encoder, channel A
  INTG0_QB = 0xFFF00001, // Encoder 0, quadrature encoder, channel B
  INTG0_ABS = 0xFFF00002, // Integrator 0, absolute mode
  INTG0_ENC = 0xFFF00003, // Integrator 0, encoder mode
  INTG1_QA = 0xFFF00100, // Encoder 1, quadrature encoder, channel A
  INTG1_QB = 0xFFF00101, // Encoder 1, quadrature encoder, channel B
  INTG1_ABS = 0xFFF00102, // Integrator 1, absolute mode
  INTG1_ENC = 0xFFF00103, // Integrator 1, encoder mode
}

export const HID_USAGE_LABELS: Record<number, string> = {
  [HidUsage.NOT_ASSIGNED]: 'Not Assigned',
  [HidUsage.X]: 'X',
  [HidUsage.Y]: 'Y',
  [HidUsage.Z]: 'Z',
  [HidUsage.RX]: 'RX',
  [HidUsage.RY]: 'RY',
  [HidUsage.RZ]: 'RZ',
  [HidUsage.HAT_SWITCH]: 'Hat Switch',
  [HidUsage.ACCELL]: 'Accelerator',
  [HidUsage.BRAKE]: 'Brake',
  [HidUsage.BUTTON_1]: 'Button 1',
  [HidUsage.BUTTON_2]: 'Button 2',
  [HidUsage.BUTTON_3]: 'Button 3',
  [HidUsage.BUTTON_4]: 'Button 4',
  [HidUsage.BUTTON_5]: 'Button 5',
  [HidUsage.BUTTON_6]: 'Button 6',
  [HidUsage.BUTTON_7]: 'Button 7',
  [HidUsage.BUTTON_8]: 'Button 8',
  [HidUsage.BUTTON_9]: 'Button 9',
  [HidUsage.BUTTON_10]: 'Button 10',
  [HidUsage.BUTTON_11]: 'Button 11',
  [HidUsage.BUTTON_12]: 'Button 12',
  [HidUsage.BUTTON_13]: 'Button 13',
  [HidUsage.BUTTON_14]: 'Button 14',
  [HidUsage.BUTTON_15]: 'Button 15',
  [HidUsage.BUTTON_16]: 'Button 16',
  [HidUsage.BUTTON_17]: 'Button 17',
  [HidUsage.BUTTON_18]: 'Button 18',
  [HidUsage.BUTTON_19]: 'Button 19',
  [HidUsage.BUTTON_20]: 'Button 20',
  [HidUsage.BUTTON_21]: 'Button 21',
  [HidUsage.BUTTON_22]: 'Button 22',
  [HidUsage.BUTTON_23]: 'Button 23',
  [HidUsage.BUTTON_24]: 'Button 24',
  [HidUsage.BUTTON_25]: 'Button 25',
  [HidUsage.BUTTON_26]: 'Button 26',
  [HidUsage.BUTTON_27]: 'Button 27',
  [HidUsage.BUTTON_28]: 'Button 28',
  [HidUsage.BUTTON_29]: 'Button 29',
  [HidUsage.BUTTON_30]: 'Button 30',
  [HidUsage.BUTTON_31]: 'Button 31',
  [HidUsage.BUTTON_32]: 'Button 32',
  [HidUsage.INTG0_QA]: 'INT0.A',
  [HidUsage.INTG0_QB]: 'INT0.B',
  [HidUsage.INTG0_ABS]: 'INT0.Abs',
  [HidUsage.INTG0_ENC]: 'INT0.Enc',
  [HidUsage.INTG1_QA]: 'INT1.A',
  [HidUsage.INTG1_QB]: 'INT1.B',
  [HidUsage.INTG1_ABS]: 'INT1.Abs',
  [HidUsage.INTG1_ENC]: 'INT1.Enc',
};

// Control type meta: classify HID usages as 'analog', 'digital', or 'hatswitch'
export type HidControlType = '' | 'analog' | 'digital' | 'hatswitch' | 'analog-intg' | 'digital-intg';

export const HID_USAGE_TYPE: Record<number, HidControlType> = {
  [HidUsage.NOT_ASSIGNED]: '',

  // Analog axes
  [HidUsage.X]: 'analog',
  [HidUsage.Y]: 'analog',
  [HidUsage.Z]: 'analog',
  [HidUsage.RX]: 'analog',
  [HidUsage.RY]: 'analog',
  [HidUsage.RZ]: 'analog',
  [HidUsage.ACCELL]: 'analog',
  [HidUsage.BRAKE]: 'analog',

  [HidUsage.INTG0_ABS]: 'analog-intg',
  [HidUsage.INTG0_ENC]: 'analog-intg',
  [HidUsage.INTG1_ABS]: 'analog-intg',
  [HidUsage.INTG1_ENC]: 'analog-intg',

  // Hat switch
  [HidUsage.HAT_SWITCH]: 'hatswitch',

  // Digital buttons
  [HidUsage.BUTTON_1]: 'digital',
  [HidUsage.BUTTON_2]: 'digital',
  [HidUsage.BUTTON_3]: 'digital',
  [HidUsage.BUTTON_4]: 'digital',
  [HidUsage.BUTTON_5]: 'digital',
  [HidUsage.BUTTON_6]: 'digital',
  [HidUsage.BUTTON_7]: 'digital',
  [HidUsage.BUTTON_8]: 'digital',
  [HidUsage.BUTTON_9]: 'digital',
  [HidUsage.BUTTON_10]: 'digital',
  [HidUsage.BUTTON_11]: 'digital',
  [HidUsage.BUTTON_12]: 'digital',
  [HidUsage.BUTTON_13]: 'digital',
  [HidUsage.BUTTON_14]: 'digital',
  [HidUsage.BUTTON_15]: 'digital',
  [HidUsage.BUTTON_16]: 'digital',
  [HidUsage.BUTTON_17]: 'digital',
  [HidUsage.BUTTON_18]: 'digital',
  [HidUsage.BUTTON_19]: 'digital',
  [HidUsage.BUTTON_20]: 'digital',
  [HidUsage.BUTTON_21]: 'digital',
  [HidUsage.BUTTON_22]: 'digital',
  [HidUsage.BUTTON_23]: 'digital',
  [HidUsage.BUTTON_24]: 'digital',
  [HidUsage.BUTTON_25]: 'digital',
  [HidUsage.BUTTON_26]: 'digital',
  [HidUsage.BUTTON_27]: 'digital',
  [HidUsage.BUTTON_28]: 'digital',
  [HidUsage.BUTTON_29]: 'digital',
  [HidUsage.BUTTON_30]: 'digital',
  [HidUsage.BUTTON_31]: 'digital',
  [HidUsage.BUTTON_32]: 'digital',

  [HidUsage.INTG0_QA]: 'digital-intg',
  [HidUsage.INTG0_QB]: 'digital-intg',
  [HidUsage.INTG1_QA]: 'digital-intg',
  [HidUsage.INTG1_QB]: 'digital-intg',
};
